import { actionConst } from '../constants/new-wdocument.constants';

const defaultState = {
	newDocumentModalVisible: false,
	listDocumentType: [],
	request: null,
	posted: false,
	updatedRequest: null,
	contractorId: undefined
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.RESET_POSTED_REQUEST: {
			return {
				...state,
				postRequestID: null
			}
		}
		case actionConst.POST_DOCUMENT: {
			return {
				...state,
				posted: true,
				updatedRequest: action.payload
			}
		}
		case actionConst.DELETE_DOCUMENT: {
			return {
				...state,
				deleted: true,
				updatedRequest: action.payload
			}
		}
		case 'DOCUMENTS_REFRESHED': {
			return {
				...state,
				posted: false,
				deleted: false,
				updatedRequest: null
			}
		}
		case actionConst.FETCH_DOCTYPE_REF + '_FULFILLED': {
			return {
				...state,
				listDocumentType: action.payload.data.data || action.payload.data
			}
		}
	//	case actionConst.UPDATE_NEW_DOCUMENT_MODAL: {
//			return {
	//			...state,
//				contractorId: action.contractorId,
		//		posted: false
			//}
		//}
		case actionConst.OPEN_NEW_DOCUMENT_MODAL: {
			return {
				...state,
				newDocumentModalVisible: true,
				request: action.payload,
				contractorId: action.contractorId,
				posted: false
			}
		}
		case actionConst.CLOSE_NEW_DOCUMENT_MODAL: {
			return {
				...state,
				newDocumentModalVisible: false
			}
		}
		default:
			return state;
	}
}